import {
    ADD_SERVICE_FAIL,
    ADD_SERVICE_SUCCESS,
    DELETE_SERVICE_FAIL,
    DELETE_SERVICE_SUCCESS,
    EXPORT_SERVICE_FAIL,
    EXPORT_SERVICE_SUCCESS,
    GET_SERVICE_DETAILS_FAIL,
    GET_SERVICE_DETAILS_SUCCESS,
    GET_SERVICE_LISTING_FAIL,
    GET_SERVICE_LISTING_SUCCESS,
    RESET_SERVICE_ATTACHMENT_STATE,
    RESET_SERVICE_STATE,
    UPDATE_SERVICE_FAIL,
    UPDATE_SERVICE_SUCCESS
} from "./actionTypes"

const INIT_STATE = {
    serviceListing: [],
    serviceDetails: [],
    addService: [],
    updateService: [],
    deleteService: [],
    exportService: [],
    error: [],
}

const Service = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_SERVICE_LISTING_SUCCESS:
            return {
                ...state,
                serviceListing: action.payload
            }
        case GET_SERVICE_LISTING_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case GET_SERVICE_DETAILS_SUCCESS:
            return {
                ...state,
                serviceDetails: action.payload
            }
        case GET_SERVICE_DETAILS_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case ADD_SERVICE_SUCCESS:
            return {
                ...state,
                addService: action.payload
            }
        case ADD_SERVICE_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case UPDATE_SERVICE_SUCCESS:
            return {
                ...state,
                updateService: action.payload
            }
        case UPDATE_SERVICE_FAIL:
            return {
                ...state,
                error: action.payload,
                updateService: action.payload,
            }

        case DELETE_SERVICE_SUCCESS:
            return {
                ...state,
                deleteService: action.payload
            }
        case DELETE_SERVICE_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case EXPORT_SERVICE_SUCCESS:
            return {
                ...state,
                exportService: action.payload
            }
        case EXPORT_SERVICE_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case RESET_SERVICE_ATTACHMENT_STATE:
            return {
                ...state,
                exportService: [],
                error: [],
            }
        case RESET_SERVICE_STATE:
            return {
                ...state,
                serviceListing: [],
                serviceDetails: [],
                addService: [],
                updateService: [],
                deleteService: [],
                exportService: [],
                error: [],
            }
        default:
            return state
    }
}

export default Service
